import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/chevron-up.svg'


const _hoisted_1 = { class: "bg-[#F9F8F6] rounded-primary-radius" }
const _hoisted_2 = { class: "text-lg sm:text-[20px] leading-[30px] tracking-[0.01rem] text-primary-text-color font-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col lg:flex-row items-start p-3 pt-0 gap-3 h-[196px]"
}
const _hoisted_4 = { class: "flex-1 flex flex-col items-start gap-2" }
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_7 = { class: "flex flex-col gap-1" }
const _hoisted_8 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_9 = { class: "flex flex-col gap-1" }
const _hoisted_10 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_11 = { class: "flex flex-col gap-1" }
const _hoisted_12 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_13 = { class: "flex-1 flex flex-col items-start gap-2" }
const _hoisted_14 = { class: "flex flex-col gap-1" }
const _hoisted_15 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_16 = { class: "flex flex-col gap-1" }
const _hoisted_17 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }
const _hoisted_18 = { class: "flex flex-col gap-1" }
const _hoisted_19 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-norma" }
const _hoisted_20 = { class: "flex flex-col gap-1" }
const _hoisted_21 = { class: "text-base leading-[20px] tracking-[0.01rem] text-primary-text-color font-normal" }

import { Project } from "@/types";

import { useTranslate } from "@/composables/useTranslate";

type Props = {
  project: Project;
  showDetails: boolean;
};

type Emits = {
  (event: "toggleDetails"): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'TechnicalDetails',
  props: {
    project: {},
    showDetails: { type: Boolean }
  },
  emits: ["toggleDetails"],
  setup(__props: any) {




const { t } = useTranslate();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleDetails'))),
      class: "flex items-center justify-between p-2 h-[48px] cursor-pointer"
    }, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)("phase.technical_details")), 1),
      _createElementVNode("img", {
        class: _normalizeClass(["cursor-pointer", __props.showDetails ? 'rotate-0' : 'rotate-180']),
        src: _imports_0,
        alt: ""
      }, null, 2)
    ]),
    (__props.showDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " VNB ", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.project?.vnb ? __props.project?.vnb : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Wechselrichter ", -1)),
              _createElementVNode("p", _hoisted_8, _toDisplayString(__props.project?.wechselrichter ? __props.project?.wechselrichter : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Speicher ", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(__props.project?.speicher ? __props.project?.speicher : "-."), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Masskonzept ", -1)),
              _createElementVNode("p", _hoisted_12, _toDisplayString(__props.project?.masskonzept ? __props.project?.masskonzept : "-"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " WB ", -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(__props.project?.wb ? __props.project?.wb : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Number of Modules ", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(__props.project?.numberOfModules ? __props.project?.numberOfModules : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[7] || (_cache[7] = _createElementVNode("h4", { class: "text-sm font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " Modul Type ", -1)),
              _createElementVNode("p", _hoisted_19, _toDisplayString(__props.project?.modulType ? __props.project?.modulType : "-"), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]" }, " IMB Date ", -1)),
              _createElementVNode("p", _hoisted_21, _toDisplayString(__props.project?.ibnDate
                ? new Date(__props.project?.ibnDate).toLocaleDateString("de")
                : "-"), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})